import { ContentExpander, SecondaryText } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { StyledContentExpanderContent } from '../../StyledContentExpanderContent';

import { StyledMedicalLeaveFormCodesDescriptions } from './StyledMedicalLeaveFormCodesDescriptions';
import { CODES } from './workInability.constants';

const MedicalLeaveFormCodesDescriptions = (): JSX.Element => {
   return (
      <StyledMedicalLeaveFormCodesDescriptions>
         <ContentExpander
            expandLabel={commonTranslationKeys.showCodesDescriptions}
            collapseLabel={commonTranslationKeys.hideCodesDescriptions}
            testId='medicalLeaveCodesDescriptions'
         >
            <StyledContentExpanderContent>
               {CODES.map((code) => (
                  <SecondaryText
                     key={code}
                     text={commonTranslationKeys[`code${code}Description` as const]}
                     testId={code}
                  />
               ))}
            </StyledContentExpanderContent>
         </ContentExpander>
      </StyledMedicalLeaveFormCodesDescriptions>
   );
};

export { MedicalLeaveFormCodesDescriptions };
